import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=c398d6de&scoped=true&"
import script from "./VerificationCode.vue?vue&type=script&lang=js&"
export * from "./VerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=c398d6de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c398d6de",
  null
  
)

export default component.exports